import { devices } from '@src/styles/theme';
import styled from 'styled-components';
import HeartSvg from '@src/assets/imgs/heart.svg';
import ShareSvg from '@src/assets/imgs/share.svg';
import ShareBlackSvg from '@src/assets/imgs/shareBlack.svg';
import CommentSvg from '@src/assets/imgs/comment.svg';
import { IBoardContent, IContent } from '@src/interfaces/community';
import {
  useCommunityListMutaion,
  useDonationShareMutaion,
} from '@src/hooks/useCommunitys';
import useToast from '@src/hooks/useToast';
import { copyClipBoard } from '@src/utils/community';
import * as gtag from '@src/utils/gtag';
/**
 *
 * @returns 좋아요, 댓글, 공유 컴포넌트
 * 다만 23-12-26 기준 새롭게 생긴 컴포넌트다
 * 조건부 랜더링이 많아서 고민이다..
 */

type Props = {
  community: IContent | IBoardContent;
  isImage: boolean;
};
const NewStatus = ({ community, isImage }: Props) => {
  const { mutate: onLike } = useCommunityListMutaion('board');
  const { showToast } = useToast();
  console.log(community, 'NewStatus 컴포넌트');
  return (
    <>
      <Flex isImage={isImage}>
        <StatusText
          onClick={(e) => {
            e.stopPropagation();
            onLike(community.uuid);
          }}
        >
          <HeartIcon isActive={community.liked} />
          <span>공감해요 {community?.likeCount}</span>
        </StatusText>
        <StatusText>
          <CommentIcon />
          <span>댓글 {community.repliesCount} </span>
        </StatusText>
        <StatusText
          onClick={(e) => {
            e.stopPropagation();
            showToast('info', `클립보드에 복사되었습니다.`);
            gtag.share('board');
            copyClipBoard(
              `${window.location.origin}/community/board/detail/${community?.uuid}`
            );
          }}
        >
          <ShareBlackIcon />
          <span>공유</span>
        </StatusText>
      </Flex>
    </>
  );
};
const Flex = styled.div<{ isImage: boolean }>`
  display: flex;
  div:not(:first-child) {
    margin-left: 8px;
  }
  @media ${devices.tablet} {
    margin-top: ${({ isImage }) => (isImage ? '18px' : '8px')};
  }
`;

const FlexJustBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StatusText = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.commonColor.gray005};
  letter-spacing: -0.6px;
  display: flex;
  align-items: center;
  > span {
    margin-left: 6px;
    font-family: 'Regular';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */
    letter-spacing: -0.6px;
  }
  cursor: pointer;
  @media ${devices.tablet} {
    > span {
      font-size: 11px;
    }
  }
`;

const HeartIcon = styled(({ isActive, ...props }) => <HeartSvg {...props} />)<{
  isActive: boolean;
}>`
  & > path {
    fill: ${({ theme, isActive }) =>
      isActive ? theme.commonColor.pink004 : theme.commonColor.white};
    stroke: ${({ theme, isActive }) =>
      isActive ? theme.commonColor.pink004 : theme.commonColor.gray005};
  }
  /* width: 18px;
  height: 18px; */
`;

const CommentIcon = styled(CommentSvg)`
  & > path {
    fill: ${({ theme }) => theme.commonColor.gray005};
  }
  /* width: 18px;
  height: 18px; */
`;

const ShareIcon = styled(ShareSvg)``;

const ShareBlackIcon = styled(ShareBlackSvg)``;

const ShareButton = styled.button<{ isImage: boolean }>`
  background-color: ${({ theme }) => theme.commonColor.pink004};
  border-radius: 8px;
  padding: 6px 17px;
  color: ${({ theme }) => theme.commonColor.white};
  display: flex;
  flex-direction: row;
  align-items: center;
  > span {
    margin-left: 6px;
    font-family: 'Regular';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px; /* 128.571% */
    letter-spacing: -0.6px;
  }
  cursor: pointer;
  @media ${devices.tablet} {
    padding: 4px 12px;
    margin-top: ${({ isImage }) => (isImage ? '18px' : '4px')};
    > span {
      font-size: 11px;
    }
  }
`;
export default NewStatus;
